import ChatCenterIcon from './ChatCenterIcon';
import FaqIcon from './FaqIcon';
import LeadIcon from './LeadIcon';
import LogoutIcon from './LogoutIcon';
import NewsIcon from './NewsIcon';
import OverviewIcon from './OverviewIcon';
import SchedulingIcon from './SchedulingIcon';
import SettingsIcon from './SettingsIcon';
import SoundDisabledIcon from './SoundDisabledIcon';
import SoundEnabledIcon from './SoundEnabledIcon';

const HeaderV2Icons = {
  ChatCenterIcon,
  FaqIcon,
  LeadIcon,
  LogoutIcon,
  NewsIcon,
  OverviewIcon,
  SchedulingIcon,
  SettingsIcon,
  SoundDisabledIcon,
  SoundEnabledIcon,
};

export default HeaderV2Icons;
